<div class="dutch-modal-container tw-flex tw-flex-col tw-w-full">

  <!-- Header -->
  <div
    class="
      modal-header
      tw-flex
      tw-items-center
      tw-justify-between
      tw-bg-[#1B478A]
      tw-text-[#FFFFFF]
      tw-rounded-t-[12px]
      tw-px-[16px]
      tw-py-[14px]
    "
  >
    <p class="tw-text-[18px] tw-font-bold tw-uppercase tw-mb-0" data-cy="dutch-title">
      {{ 'ui.wager.place.wager' | translate: 'Place Wager' }}
    </p>
    <button
      type="button"
      mat-icon-button
      (click)="close()"
      attr.aria-label="{{ 'generic.close' | translate: 'Close' }}"
      class="!tw-text-white"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="modal-body tw-bg-white tw-px-[20px] tw-py-[16px]">

    <!-- Race / pool / runners summary -->
    <div
      class="race-pool tw-border-b tw-border-[#2F80EC] tw-pb-[8px] tw-mb-[12px]"
    >
      <span
        class="tw-block tw-uppercase tw-font-bold tw-text-[18px] tw-text-[#0E2543]"
        data-cy="dutch-event-name"
      >
        {{ eventName }}
      </span>
      <span
        class="tw-uppercase tw-font-bold tw-text-[16px] tw-text-[#0E2543]"
        data-cy="dutch-race-id"
      >
        {{ 'generic.race' | translate: 'Race' }} {{ dutchTicket?.RaceId }}
      </span>
      <span
        class="tw-uppercase tw-font-bold tw-text-[16px] tw-text-[#0E2543] tw-ml-[8px]"
        data-cy="dutch-pool-runners"
      >
        {{ pool?.PoolId }}
        {{ modifier === 'DutchCost' ? 'Dutch' : (modifier || '') }}
        {{ selectedRunners }}
      </span>
    </div>

    <!-- Current ROI -->
    <div class="current-roi tw-border-b tw-border-[#6C6C6C] tw-pb-[8px]">
      <span class="tw-font-bold tw-text-[15px] tw-text-[#1B478A]" data-cy="dutch-roi">
        {{ 'wager.custommod.currentroi' | translate: 'Current ROI' }}
        <span class="tw-text-[#036E23] tw-ml-[6px]">{{ minPayout }}%</span>
        <span class="tw-text-[#036E23] tw-ml-[4px]">{{ maxPayout }}%</span>
      </span>
    </div>

    <!-- Bet rows table -->
    <div class="current-bets tw-mt-[6px]">
      @if (dutchTicket?.Wagers?.length) {
        <div class="tw-max-h-[260px] tw-overflow-y-auto">
          @for (item of dutchTicket.Wagers; track item; let i = $index) {
            <div
              class="
                bet-row
                tw-flex
                tw-flex-wrap
                tw-items-center
                tw-justify-between
                tw-gap-x-[10px]
                tw-gap-y-[2px]
                tw-border-b
                tw-border-[#B4B3B3]
                tw-py-[8px]
              "
            >
              <span
                class="amount1 tw-font-bold tw-text-[13px] tw-text-[#0E2543] tw-min-w-[60px]"
                [attr.data-cy]="'dutch-amount-' + i"
              >
                ${{ item?.BaseAmount | number:'1.2-2' }}
              </span>

              <span
                class="
                  amount-percent tw-font-semibold tw-text-[13px] tw-text-[#1B478A]
                  tw-flex-1 tw-text-center
                "
                [attr.data-cy]="'dutch-runner-' + i"
              >
                {{ item?.getWagerString()[2] }}
              </span>

              <span
                class="amount2 tw-font-bold tw-text-[13px] tw-text-[#036E23] tw-min-w-[60px] tw-text-right"
                [attr.data-cy]="'dutch-payout-' + i"
              >
                ${{ dutchAmountHolder?.[i]?.[1] }}
              </span>

              <button
                type="button"
                mat-icon-button
                color="warn"
                class="trash-action"
                (click)="removeBet(i)"
                [attr.data-cy]="'dutch-trash-' + i"
                attr.aria-label="{{ 'ui.wager.remove.wager' | translate: 'Remove wager' }}"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>

              @if (item?.Error) {
                <div
                  class="no-valid-wager tw-w-full tw-text-[13px] tw-text-[#D32F2F] tw-pl-[2px]"
                  [attr.data-cy]="'dutch-msg-' + i"
                >
                  {{ item.Error }}
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <p class="tw-text-center tw-text-[14px] tw-text-[#6C6C6C] tw-py-[14px]">
          {{ 'ui.wager.no.dutch.wagers.available' | translate: 'No dutch wagers available.' }}
        </p>
      }
    </div>

    <!-- Total cost -->
    <div class="tw-mt-[16px]">
      <span class="tw-font-bold tw-text-[16px] tw-text-[#0E2543]" data-cy="dutch-total-cost">
        {{ 'ui.generic.total.cost' | translate: 'Total Cost:' }}
        <span class="tw-text-[#036E23] tw-ml-[4px]">
          ${{ totalCost | number:'1.2-2' }}
        </span>
      </span>
    </div>

  </div>

  <!-- Actions -->
  <div
    class="
      modal-actions
      tw-flex
      tw-justify-between
      tw-gap-[10px]
      tw-bg-white
      tw-rounded-b-[12px]
      tw-px-[20px]
      tw-pb-[18px]
      tw-pt-[6px]
    "
  >
    <button
      type="button"
      mat-flat-button
      color="primary"
      class="!tw-flex-1 !tw-rounded-full submit-btn"
      data-cy="dutch-submit-btn"
      (click)="submitAll()"
    >
      {{ 'generic.submit' | translate: 'SUBMIT' }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="accent"
      class="!tw-flex-1 !tw-rounded-full save-btn"
      data-cy="dutch-save-btn"
      (click)="saveAll()"
    >
      {{ 'generic.save' | translate: 'SAVE' }}
    </button>
    <button
      type="button"
      mat-stroked-button
      color="warn"
      class="!tw-flex-1 !tw-rounded-full close-btn"
      data-cy="dutch-close-btn"
      (click)="close()"
    >
      {{ 'generic.close' | translate: 'CLOSE' }}
    </button>
  </div>

</div>
